export const initialState = {
  id: null,
  title: null,
  body: null,
  users: [],
  mandatory: false,
  resource: null,
  resource_id: null,
  resource_class: null,
  status: 'pending'
};

export const state = {
  notifications: [],
  currentNotification: initialState,
  filters: {
    searchQuery: "",
    categories:[]
  },
  sortBy: {
    field: "created_time",
    direction: "desc",
  },
  pagination: {
    total: 10,
    per_page: 10,
    current_page: 1,
    last_page: 1,
    from: 1,
    to: 10,
  },
};
